// src/utils/audio.js

export async function playSound(soundFile) {
  try {
    // This path correctly points to the file in the 'public' folder.
    const audio = new Audio(`/sounds/${soundFile}`);
    await audio.play();
  } catch (error) {
    console.error(`Error playing sound: ${soundFile}`, error);
  }
}
